export default {
    customService: [

        {
            name: '微校+学校管理',
            moduleIcon: 'xxgl',
            routePath: '/main/customService/schoolManage/schoolList',
            permissionPath: '/wyms/school/querySchoolList'
        },
        {
            name: '农行学校管理',
            moduleIcon: 'xxgl',
            routePath: '/main/customService/schoolManage/schoolListAbc',
            permissionPath: '/wyms/school/querySchoolList'
        },
        {
            name: '建行学校管理',
            moduleIcon: 'xxgl',
            routePath: '/main/customService/schoolManage/schoolListCcb',
            permissionPath: '/wyms/school/querySchoolList'
        },
        {
            name: '应用接入',
            moduleIcon: 'yyjr',
            routePath: '/main/customService/appInsert/appInsertIndex',
            permissionPath: '/wyms/school/querySchoolList'
        },
        {
            name: '用户检索',
            moduleIcon: 'jxsgl',
            permissionPath: '/wyms/schoolUser/index',
            routePath: '/main/customService/schoolManage/userRetrievalindex',
        },

    ],
    developmentSystem: [
        {
            name: '权限体系',
            moduleIcon: 'qxtx',
            index: '/main/developmentSystem/permissionSystem',
            permissionPath: '/wyms/perm',
            children: [
                {
                    name: '应用管理',
                    routePath: '/main/developmentSystem/permissionSystem/moduleApp/moduleAppList',
                    permissionPath: '/wyms/module/queryModuleList',
                },
                {
                    name: '权限管理',
                    routePath: '/main/developmentSystem/permissionSystem/permission/permission',
                    permissionPath: '/wyms/permission/queryPermissionByPidZ',
                },
                {
                    name: '角色管理',
                    routePath: '/main/developmentSystem/permissionSystem/role/roleList',
                    permissionPath: '/wyms/roleInfo/queryRoleInfoList',
                },
                {
                    name: '应用角色权限',
                    routePath: '/main/developmentSystem/permissionSystem/moduleRolePermission/moduleRolePermissionList',
                    permissionPath: '/wyms/moduleRolePerm/queryModuleRolePermList'
                },
                {
                    name: '接口权限',
                    routePath: '/main/developmentSystem/permissionSystem/apiPermission/apiPermissionList',
                    permissionPath: '/wyms/apiManage/queryApiPermissionByPid'
                },
                {
                    name: '在线工单提问',
                    isOpen: true, // 弹出新窗口
                    routePath: 'https://qingflow.com/app/ff9232e1/list/1',
                    permissionPath: ''
                }
            ]
        },
        {
            name: '套件体系',
            moduleIcon: 'tjtx',
            index: '/main/developmentSystem/suiteSystem',
            permissionPath: '/wyms/suiteZ',
            children: [
                {
                    name: '套件管理',
                    routePath: '/main/developmentSystem/suiteSystem/suiteManage/suiteManageIndex',
                    permissionPath: '/wyms/suite/list',
                },
                {
                    name: '套件应用',
                    routePath: '/main/developmentSystem/suiteSystem/suiteApp/suiteAppIndex',
                    permissionPath: '/wyms/suiteModule/showModuleList',
                },
                {
                    name: '套件角色',
                    routePath: '/main/developmentSystem/suiteSystem/suiteRole/suiteRoleIndex',
                    permissionPath: '/wyms/suiteRole/list',
                },
            ]
        },
        {
            name: '常用工具',
            moduleIcon: 'cygj',
            index: '/main/developmentSystem/commonTool',
            permissionPath: '/wyms/tools',
            children: [
                {
                    name: '刷权限',
                    routePath: '/main/developmentSystem/commonTool/rolePermissionManage',
                    permissionPath: '/wyms/srp/moduleRolePerm',

                },
                {
                    name: 'redis管理',
                    routePath: '/main/developmentSystem/commonTool/redisManageList',
                    permissionPath: '/wyms/redisindex',

                }
            ]
        },
        {
            name: '通知类应用',
                moduleIcon: 'qxtx',
                index: '/main/developmentSystem/releaseModuleindex',
                routePath: '/main/developmentSystem/releaseModuleindex',
                permissionPath: '/pushMsg/msgInit',
            }, {
            name: '外链系统',
            moduleIcon: 'wlxt',
            index: '/main/developmentSystem/outSystem',
            routePath: '/main/developmentSystem/outSystem',
            permissionPath: '/wyms/link',
        }
    ],
    systemMaintain: [
        {
            name: '系统数据',
            moduleIcon: 'xtsj',
            index: '/main/systemMaintain/systemData',
            permissionPath: '/wyms/sysDicZ',
            children: [
                {
                    name: '系统字典',
                    routePath: '/main/systemMaintain/systemData/systemDict',
                    permissionPath: '/wyms/sysDic/loadDicTypeZ'
                },
                {
                    name: '系统校历',
                    routePath: '/main/systemMaintain/systemData/schoolCalendar/schoolCalendarList',
                    permissionPath: '/wyms/schoolTime/schoolTimeList'
                },
                {
                    name: '课程管理',
                    routePath: '/main/systemMaintain/systemData/subjectManagement/subjectList'
                },
                {
                    name: '用户手册',
                    routePath: '/main/systemMaintain/systemData/userManual/userManualIndex'
                }
            ]
        },
        {
            name: '班牌模板',
            moduleIcon: 'bpmb',
            index: '/main/systemMaintain/classcard',
            permissionPath: '/wyms/classcard/classcardTemp',
            children: [
                {
                    name: '组件库',
                    routePath: '/main/systemMaintain/classcard/module/moduleList'
                },
                {
                    name: '系统模板',
                    routePath: '/main/systemMaintain/classcard/template/templateList'
                }
            ]
        },
        {
            name: '经销商管理',
            moduleIcon: 'jxsgl',
            index: '/main/systemMaintain/dealerManage',
            permissionPath: '/wyms/bussiness/',
            children: [
                {
                    name: '经销商管理',
                    routePath: '/main/systemMaintain/dealerManage/dealer/dealerManageList',
                    permissionPath: '/wyms/bussiness/queryBussinessList',
                },
                {
                    name: '客服组管理',
                    routePath: '/main/systemMaintain/dealerManage/customerService/groupList',
                    permissionPath: '/wyms/customerGroup/listGroup',
                },
                {
                    name: '平台角色管理',
                    routePath: '/main/systemMaintain/dealerManage/platformRole/platformRoleIndex',
                    permissionPath: '/wyms/platformRole/queryRoleList',

                },
                {
                    name: '经销商套件设置',
                    routePath: '/main/systemMaintain/dealerManage/dealerSuite/dealerSuiteIndex',
                    permissionPath: '/wyms/businessSuite/queryBussinessSuiteList',
                }
            ]
        },
        {
            name: '学习',
            moduleIcon: 'xx',
            index: '/main/systemMaintain/study',
            permissionPath: '/wyms/study/stuStudy',
            children: [
                {
                    name: '字库管理',
                    routePath: '/main/systemMaintain/study/charLib/charLib',
                },
                {
                    name: '平台书库',
                    routePath: '/main/systemMaintain/study/library/libraryIndex'
                },
                {
                    name: '年级书库',
                    routePath: '/main/systemMaintain/study/readingplatformbookmanagementindex',
                },
                {
                    name: '资源图谱',
                    routePath: '/main/systemMaintain/study/resourceMap/resourceMapIndex'
                },
                {
                    name: '试卷模板',
                    routePath: '/main/systemMaintain/study/achievement/achievementindex'
                }
            ]
        },
        {
            name: 'sql工具',
            moduleIcon: 'xx',
            index: '/main/systemMaintain/sql',
            permissionPath: '/wyms/sqlTool',
            children: [
                {
                    name: 'sql模板',
                    routePath: '/main/systemMaintain/sql/sqlTemplateList',
                },
                {
                    name: '执行记录',
                    routePath: '/main/systemMaintain/sql/sqlExecList'
                }
            ]
        },
        {
            name: '儿童观察指南',
            moduleIcon: 'czczjk',
            routePath: '/main/systemMaintain/watchingRecords/watchingRecordsSettingList',
            permissionPath: '/childObserve/childLearnDevGuideManage'
        },
        {
            name: '硬件管理',
            moduleIcon: 'yjgl',
            index: '/main/systemMaintain/hardwareManage',
            permissionPath: '/wyms/device/deviceList',
            children: [
                {
                    name: '卡库管理',
                    routePath: '/main/systemMaintain/hardwareManage/cardList'
                },
                {
                    name: '设备库管理',
                    routePath: '/main/systemMaintain/hardwareManage/equipmentLibraryIndex'
                },
                {
                    name: '设备统计',
                    routePath: '/main/systemMaintain/hardwareManage/deviceAccounting'
                }
            ]
        },
        {
            name: '膳食营养',
            moduleIcon: 'ssyy',
            index: '/main/systemMaintain/foodSetting',
            permissionPath: '/wyms/dietary/dietaryList',
            children: [
                {
                    name: '膳食食材库',
                    routePath: '/main/systemMaintain/foodSetting/foodWarehouseindex'
                },
                {
                    name: '膳食菜品库',
                    routePath: '/main/systemMaintain/foodSetting/varietyofdishesindex'
                },
                {
                    name: '营养标准设置',
                    routePath: '/main/systemMaintain/foodSetting/nutritionSettingsindex'
                },
                {
                    name: '专家食谱',
                    routePath: '/main/systemMaintain/foodSetting/expertCookbookindex'
                },
                {
                    name: '食谱菜品库',
                    routePath: '/main/systemMaintain/foodSetting/recipesindex'
                },
            ]
        },
        {
            name: '成长册组件库',
            moduleIcon: 'czczjk',
            permissionPath: '/wyms/stuGrowth/component',
            routePath: '/main/systemMaintain/growthBook/index'
        },
        {
            name: '幼儿成长档案',
            moduleIcon: 'xx',
            index: '/main/systemMaintain/growthfootprint',
            // permissionPath: '/wyms/study/stuStudy',
            children: [
                {
                    name: '评估模板',
                    routePath: '/main/systemMaintain/growthfootprint/growthfootprintevaluationtemplateindex',
                },
                {
                    name: '排版设置',
                    routePath: '/main/systemMaintain/growthfootprint/growthfootprinttypesettingindex',
                },
                {
                    name: '组件库',
                    routePath: '/main/systemMaintain/growthfootprint/growthfootprintassemblyindex',
                }
            ]
        },
        {
            name: '敏感词管理',
            moduleIcon: 'mgcgl',
            routePath: '/main/systemMaintain/wordBlackList'
        },
        {
            name: '日志管理',
            moduleIcon: 'xx',
            index: '/main/systemMaintain/pushData',
            children: [
                {
                    name: '运维日志',
                    routePath: '/main/systemMaintain/pushData/logList'
                },
                {
                    name: '基础数据变更',
                    routePath: '/main/systemMaintain/pushData/changeLog'
                },
                {
                    name: '数据下发日志',
                    routePath: '/main/systemMaintain/pushData/pushDataLog'
                }
            ]
        },
        {
            name: '积分银行',
            moduleIcon: 'yjgl',
            index: '/main/systemMaintain/integralBank',
            children: [
                {
                    name: '积分卡模板',
                    routePath: '/main/systemMaintain/integralBank/cardTemplateList'
                },
                {
                    name: '卡片管理',
                    routePath: '/main/systemMaintain/integralBank/cardManageList'
                },
                {
                    name: '商品管理',
                    routePath: '/main/systemMaintain/integralBank/goodsManageList'
                }
            ]
        },
        {
            name: '积分规则',
            moduleIcon: 'xx',
            routePath: '/main/systemMaintain/integralrule/integralruleindex'
        },


    ],
    dataAnalysis: [
        {
            name: '活跃度统计',
            moduleIcon: 'hyd',
            routePath: '/main/dataAnalysis/activityIndex',
            permissionPath: '/wyms/schoolActive/listSchoolActive',

        },
        {
            name: '关注率统计',
            moduleIcon: 'gzl',
            routePath: '/main/dataAnalysis/attentionRateIndex',
            permissionPath: '/wyms/schoolReport/listSchoolUserReports',

        },
        {
            name: '数据统计',
            moduleIcon: 'sjtj',
            index: '/main/dataAnalysis/dataStatistics',
            permissionPath: '/wyms/statisticsWY',
            children: [
                {
                    name: '平台数据统计',
                    routePath: '/main/dataAnalysis/dataStatistics/platformDataStatistics/index',
                    permissionPath: '/wyms/statisticsWY/queryStatistic',
                },
                {
                    name: '模块数据统计',
                    routePath: '/main/dataAnalysis/dataStatistics/moduleDataStatistics/index',
                    permissionPath: '/wyms/moduleInstallStatitics/listModuleInstallDetail',
                },
                {
                    name: '套件数据统计',
                    routePath: '/main/dataAnalysis/dataStatistics/kitDataStatistics/index',
                    permissionPath: '/wyms/statisticsWY/querySuiteList',
                }
            ]
        },
        {
            name: '农行数据统计',
            moduleIcon: 'zybdtj',
            index: '/main/dataAnalysis/mobileBankAccounting',
            permissionPath: '/wyms/statisticsWY',
            children: [
                {
                    name: '掌银绑定统计',
                    routePath: '/main/dataAnalysis/mobileBankAccounting/mobileBankAccountingList',
                },
                {
                    name: '活跃度统计',
                    routePath: '/main/dataAnalysis/mobileBankAccounting/mobileBankActiveAccounting',
                },
                {
                    name: '数据报表',
                    routePath: '/main/dataAnalysis/mobileBankAccounting/mobileBankDataReport',
                },
            ]
        },
        {
            name: '行程报备统计',
            moduleIcon: 'zybdtj',
            routePath: '/main/dataAnalysis/trailRecordAccounting',
        },
       
    ],
    systemoperation:[
        {
            name: '短信管理',
            moduleIcon: 'xx',
            permissionPath: '/wyms/smsRecharge/list',
            routePath: '/main/systemoperation/shortmessage/shortmessageindex'
        },
        {
            name: 'OCR识别管理',
            moduleIcon: 'xx',
            permissionPath: '/wyms/ocr/manage',
            routePath: '/main/systemoperation/Identificationmanagement/Identificationmanagementindex'
        },
        {
            name: '放学路队套餐',
            moduleIcon: 'xx',
            permissionPath: '/schooloverCombo/wxcepManger',
            routePath: '/main/systemoperation/schoolRoadTeamPackage/schoolRoadTeamPackageindex'
        },
        {
            name: '农行活动管理',
            moduleIcon: 'xx',
            routePath: '/main/systemoperation/abcActivityManagement/abcActivityList'
        },
        {
            name: '资源使用管理',
            moduleIcon: 'xx',
            routePath: '/main/systemoperation/resourceusage/resourceusageindex'
        },
    ],
    iPayment: [
        {
            name: '首页',
            moduleIcon: 'home',
            routePath: '/main/iPayment/homePage',
            permissionPath: ''
        },
        {
            name: '学校管理',
            moduleIcon: 'xxgl',
            routePath: '/main/iPayment/schoolManage/schoolListAbc',
            permissionPath: ''
        },
        {
            name: '监管账户',
            moduleIcon: 'xtsj',
            routePath: '/main/iPayment/platformmerchant/platformmerchantindex',
            permissionPath: ''
        },
        {
            name: '资金出账管理',
            moduleIcon: 'xx',
            index: '/main/iPayment/outgoingManagement',
            permissionPath: '',
            children: [
                {
                    name: '25%资金出账',
                    routePath: '/main/iPayment/outgoingManagement/newoutgoingManagementIndex',
                    permissionPath: '',
                },
                {
                    name: '剩余资金出账',
                    routePath: '/main/iPayment/outgoingManagement/outgoingManagementIndex',
                    permissionPath: '',
                }
            ]
        },
        {
            name: '交易流水',
            moduleIcon: 'fundStatement',
            routePath: '/main/iPayment/transactionFlow/transactionFlow',
            permissionPath: ''
        },
        {
            name: '商户管理',
            moduleIcon: 'merchantMan',
            index: '/main/iPayment/merchantMan',
            permissionPath: '',
            children: [
                {
                    name: '商户列表',
                    routePath: '/main/iPayment/merchantMan/merchantIndex',
                    permissionPath: '',
                },
                {
                    name: '商户关联',
                    routePath: '/main/iPayment/merchantMan/merchantAssociationIndex',
                    permissionPath: '',
                },
                {
                    name: '支付测试',
                    routePath: '/main/iPayment/merchantMan/testpaymentIndex',
                    permissionPath: '',
                }
            ]
        },
        {
            name: '资金账单',
            moduleIcon: 'fundStatement',
            index: '/main/iPayment/fundStatement',
            permissionPath: '',
            children: [
                {
                    name: '交易流水',
                    routePath: '/main/iPayment/fundStatement/runningTab',
                    permissionPath: '',
                },
                {
                    name: '平台对账',
                    routePath: '/main/iPayment/fundStatement/platformReconciliation',
                    permissionPath: '',
                },
                {
                    name: '银行对账',
                    routePath: '/main/iPayment/fundStatement/bankReconciliation',
                    permissionPath: '',
                }
            ]
        },
        {
            name: '订单管理',
            moduleIcon: 'orderMan',
            index: '/main/iPayment/orderMan',
            permissionPath: '',
            children: [
                {
                    name: '支付订单',
                    routePath: '/main/iPayment/orderMan/paymentOrderIndex',
                    permissionPath: '',
                },
                {
                    name: '退款订单',
                    routePath: '/main/iPayment/orderMan/refundOrderIndex',
                    permissionPath: '',
                }
            ]
        },
        {
            name: '通知记录',
            moduleIcon: 'noticeRecord',
            index: '/main/iPayment/noticeRecord',
            permissionPath: '',
            children: [
                {
                    name: '支付通知',
                    routePath: '/main/iPayment/noticeRecord/payNotice',
                    permissionPath: '',
                },
                {
                    name: '业务通知',
                    routePath: '/main/iPayment/noticeRecord/businessNotice',
                    permissionPath: '',
                }
            ]
        }
    ],
    newiPayment: [
        {
            name: '首页',
            moduleIcon: 'home',
            routePath: '/main/newiPayment/homePage',
            permissionPath: ''
        },
        {
            name: '资金出账审批',
            moduleIcon: 'orderMan',
            routePath: '/main/newiPayment/fundApplicationApproval/fundApplicationApprovalIndex',
            permissionPath: ''
        },
        {
            name: '收费项目审批',
            moduleIcon: 'orderMan',
            routePath: '/main/newiPayment/fundApplicationApproval/newfundApplicationApprovalIndex',
            permissionPath: ''
        },
        {
            name: '驾驶舱',
            isOpen: true, // 弹出新窗口
            moduleIcon: 'orderMan',
            routePath: location.origin + location.pathname + '#/cockpitHome',
            permissionPath: ''
        },
    ]
}



// WEBPACK FOOTER //
// ./src/router/moduleList.js